import { render, staticRenderFns } from "./AdminToggle.vue?vue&type=template&id=52020dfb"
import script from "./AdminToggle.vue?vue&type=script&lang=js"
export * from "./AdminToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports